import { MCPServerService } from '@kizen/api/mcp';
import AxiosService from './AxiosService';

const instance = new MCPServerService(AxiosService);
Object.freeze(instance);

export default instance;
